import React, { useEffect, useRef, useState } from "react";
import TopBar from "@/components/TopBar";
import { useCoachChat } from "@/hooks/useCoachChat";
import { Bubble, ChatEmptyState, ChatInput, QuickActionsSidebar } from "@/components/ai/ChatParts";

export default function AICoach() {
  const { messages, streaming, send } = useCoachChat();
  const [input, setInput] = useState("");
  const scrollRef = useRef(null);

  useEffect(() => {
    scrollRef.current?.scrollTo({ top: scrollRef.current.scrollHeight, behavior: "smooth" });
  }, [messages, streaming]);

  const ask = (text) => {
    if (!text.trim() || streaming) return;
    setInput("");
    send(text);
  };
  const submit = (e) => { e.preventDefault(); ask(input); };
  const lastIdx = messages.length - 1;

  return (
    <div data-testid="ai-coach-page" className="flex flex-col h-screen">
      <TopBar title="AI Football Coach" subtitle="Trained on your program. Answers in your voice." />
      <div className="flex-1 min-h-0 grid grid-cols-1 lg:grid-cols-[1fr_280px] gap-0">
        <div className="flex flex-col min-h-0 border-r border-surface-3">
          <div ref={scrollRef} className="flex-1 overflow-y-auto px-8 py-6 space-y-4">
            {messages.length === 0 && <ChatEmptyState onPick={ask} />}
            {messages.map((m, i) => (
              <Bubble key={m.id} role={m.role} content={m.content || (streaming && i === lastIdx ? "…" : "")} />
            ))}
          </div>
          <ChatInput value={input} onChange={setInput} onSubmit={submit} streaming={streaming} />
        </div>
        <QuickActionsSidebar onPick={ask} disabled={streaming} />
      </div>
    </div>
  );
}
